export default "__VITE_ASSET__aOOsE1A2__"